<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<!-- Modern Tab Switch Bar -->
<div class="voucher-auth-container">
    <div class="tab-switch-wrapper mb-3">
        <div class="custom-tab-bar">
            <button type="button" class="tab-btn" [class.active]="activeTab === 'individual'" (click)="selectTab('individual')">
                <i class="fas fa-file-invoice mr-2"></i>
                <span class="tab-title">Individual</span>
            </button>
            <button type="button" class="tab-btn" [class.active]="activeTab === 'batch'" (click)="selectTab('batch')">
                <i class="fas fa-layer-group mr-2"></i>
                <span class="tab-title">Batch Wise</span>
            </button>
        </div>
    </div>

    <!-- ==================== INDIVIDUAL TAB ==================== -->
    <div [hidden]="activeTab !== 'individual'" class="tab-content-pane">
        <div class="row m-0 col-md-12 p-0 formborder">
            <form #df="ngForm" novalidate (keydown.enter)="onSearchPendingAuth()" class="w-100">
                <div class="row align-items-center m-0 px-3 py-2">
                    <div class="col-custom-5 mb-2">
                        <span>Voucher Date From</span>
                        <div class="datepicker_feild">
                            <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="VoucherDateFrom"
                                id="VoucherDateFrom" [min]="minDate" (dateChange)="DateChange()"
                                [max]="maxDate" class="form-control input-text-css"
                                [(ngModel)]="StartDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Date To</span>
                        <div class="datepicker_feild">
                            <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="VoucherDateTo"
                                id="VoucherDateTo" [min]="minDate" (dateChange)="DateChange()"
                                [max]="maxDate"
                                class="form-control input-text-css" [(ngModel)]="EndDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Type</span>
                        <select name="VoucherType" id="VoucherType" class="form-control input-text-css"
                            [(ngModel)]="VoucherType">
                            <option value="">Select Voucher Type</option>
                            <option value="Receipt">Receipt</option>
                            <option value="Payment">Payment</option>
                            <option value="Journal">Journal</option>
                            <option value="Contra">Contra</option>
                            <option value="Disbursement">Disbursement </option>
                            <!-- <option value="Reschedule">Reschedule</option> -->
                            <option value="WriteOff">WriteOff</option>
                            <option value="Closer">Closure</option>
                            <!-- <option value="Repossessed">Repossessed</option> -->
                            <option value="Settled">Settled</option>
                            <option value="Repayment">Repayment</option>
                        </select>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Subtype</span>
                        <select name="VoucherSubType" id="VoucherSubType" class="form-control input-text-css"
                            [(ngModel)]="VoucherSubType">
                            <option value="">Select Voucher Subtype</option>
                            <option value="Loan">Loan</option>
                            <option value="Accounting">Accounting</option>
                            <option value="Partner">Partner</option>
                        </select>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Status</span>
                        <select name="Status" id="Status" class="form-control input-text-css" [(ngModel)]="Status">
                            <option value="">Select Status</option>
                            <option value="Created">Created</option>
                            <option value="Modified">Modified</option>
                            <option value="Deleted">Deleted</option>
                        </select>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Amount From</span>
                        <div class="datepicker_feild">
                            <input type="number" name="AmountFrom" id="AmountFrom" class="form-control input-text-css"
                                [(ngModel)]="AmountFrom" placeholder="Amount From" />
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Amount To</span>
                        <div class="datepicker_feild">
                            <input type="number" name="AmountTo" id="AmountTo" class="form-control input-text-css"
                                [(ngModel)]="AmountTo" placeholder="Amount To" />
                        </div>
                    </div>

                    <div class="col-custom-search mb-2 d-flex align-items-center" style="align-self: flex-end; gap: 10px;">
                        <button type="button" (click)="onSearchPendingAuth()" class="btn font-size-12 button-btn" style="white-space: nowrap;">
                            <i class="fa fa-search mr-1"></i> Search
                        </button>

                        <div class="flex-grow-1" *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">
                            <form action="" class="search-text m-0 w-100">
                                <div class="bg-light rounded rounded-pill shadow-sm">
                                    <div class="input-group">
                                        <input type="text" id="FilterInputSearch" (keyup)="applyFilter($any($event.target).value)"
                                            name="FilterInputSearch" placeholder="What're you searching for?"
                                            class="form-control border-0 bg-light" style="font-size: 11px; height: 32px;" />
                                        <div class="input-group-append">
                                            <button id="button-addon1" type="submit" class="btn btn-link text-primary p-0 pr-2">
                                                <i class="fa fa-search" style="font-size: 11px;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="mt-3" *ngIf="dataSource">
            <div class="">
                <div class="table-responsive">
                    <mat-table [dataSource]="dataSource" matSort #sort="matSort" matTableExporter #exporter="matTableExporter"
                        style="max-width: 100%; overflow: auto">
                        <ng-container matColumnDef="Select">
                            <mat-header-cell class="grid-header" *matHeaderCellDef>
                                <ng-container>
                                    <mat-checkbox name="Select" id="Select" [(ngModel)]="SelectAll"
                                        (change)="checkUncheckAll($event)" [checked]="IsSelected"></mat-checkbox>
                                </ng-container>
                            </mat-header-cell>

                            <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                                <ng-container>
                                    <mat-checkbox class="example-margin" name="IsSelected{{ i }}" id="IsSelected{{ i }}"
                                        [(ngModel)]="row.IsSelected" [checked]="row.IsSelected"></mat-checkbox>
                                </ng-container>
                            </mat-cell>

                            <mat-footer-cell *matFooterCellDef style="max-width: 3.125rem"></mat-footer-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_No">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher No
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_No }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Status">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher Status
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Status }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Type">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Voucher
                                Type</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Type }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Date">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher Date
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Date }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_CreateOn">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Create On</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_CreateOn }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Sub_Type">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Voucher Sub
                                Type</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Sub_Type }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Amount">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Amount</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Amount }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Action">
                            <mat-header-cell class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                                <app-lms-voucher-accounts-view-model [voucherid]="row.VoucherId" [index]="i" [ROW]="row" (close)="onViewModalClose($event)">
                                    <i class="fas fa-eye"></i>
                                </app-lms-voucher-accounts-view-model>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumnsModel; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnsModel"></mat-row>
                    </mat-table>

                    <div class="row m-0 pt-2 pb-1">
                        <div class="col-md-2">
                            <button class="mt-3 btn font-size-12 button-btn" (click)="exportPendingAuthTable(exporter)">
                                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                                Export
                            </button>
                        </div>
                        <div class="col-md-6 mt-3">
                            <mat-paginator #paginator [pageSizeOptions]="[20, 50]" showFirstLastButtons>
                            </mat-paginator>
                        </div>
                        <div class="col-md-2">
                            <div class="row m-0">
                                <div class="col-md-12 text-right ">
                                    <button type="button" (click)="OnApproved()" class="mt-3 btn font-size-12 button-btn"
                                        [disabled]="!hasAnyRowSelected()">
                                        Authorized
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="row m-0">
                                <div class="col-md-12 text-right">
                                    <button type="button" (click)="OnReject()" class="mt-3 btn font-size-12 button-btn"
                                        [disabled]="!hasAnyRowSelected()">
                                        Reject
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ==================== BATCH WISE TAB ==================== -->
    <div [hidden]="activeTab !== 'batch'" class="tab-content-pane">
        <div class="row m-0 col-md-12 p-0 formborder">
            <form #batchForm="ngForm" novalidate (keydown.enter)="onSearchBatch()" class="w-100">
                <div class="row align-items-center m-0 px-3 py-2">
                    <div class="col-md-3 mb-2">
                        <span>Select Employee</span>
                        <select name="EmployeeId" id="EmployeeId" class="form-control input-text-css" [(ngModel)]="EmployeeId">
                            <option value="">Select Employee</option>
                            <option *ngFor="let emp of EmployeeDropdown" [value]="emp.EmpId">
                                {{ emp.EmpName }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-3 text-left mb-3">
                        <button type="button" (click)="onSearchBatch()" class="btn font-size-12 button-btn">
                            <i class="fa fa-search mr-1"></i> Search
                        </button>
                    </div>

                    <div class="col-md-3">
                        <form action="" class="search-text">
                            <div class="bg-light rounded rounded-pill shadow-sm">
                                <div class="input-group">
                                    <input type="text" id="FilterBatchSearch" (keyup)="applyBatchFilter($any($event.target).value)"
                                        name="FilterBatchSearch" placeholder="What're you searching for?"
                                        class="form-control border-0 bg-light" />
                                    <div class="input-group-append">
                                        <button id="button-addon-batch" type="submit" class="btn btn-link text-primary">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </form>
        </div>

        <div class="mt-3" *ngIf="batchDataSource">
            <div class="table-responsive">
                <mat-table [dataSource]="batchDataSource" matSort #batchSort="matSort" style="max-width: 100%; overflow: auto">
                    <!-- Sr No Column (Left Aligned) -->
                    <ng-container matColumnDef="SrNo">
                        <mat-header-cell class="grid-header" *matHeaderCellDef> # </mat-header-cell>
                        <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                            {{ (batchPaginator?.pageIndex * batchPaginator?.pageSize) + (i + 1) }}
                        </mat-cell>
                    </ng-container>

                    <!-- Batch No Column (Centered) -->
                    <ng-container matColumnDef="Batch_no">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Batch No </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center fw-600"> {{ row.Batch_no }} </mat-cell>
                    </ng-container>

                    <!-- Created By Column (Centered) -->
                    <ng-container matColumnDef="Voucher_CreateBy">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Created By </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center"> {{ row.Voucher_CreateBy }} </mat-cell>
                    </ng-container>

                    <!-- Voucher Count Column (Centered) -->
                    <ng-container matColumnDef="VoucherIdCount">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Voucher Count </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center">
                            <span class="badge-count-pill">{{ row.VoucherIdCount }}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Created On Column (Centered) -->
                    <ng-container matColumnDef="Voucher_CreateOn">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Created On </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center"> {{ row.Voucher_CreateOn }} </mat-cell>
                    </ng-container>

                    <!-- Action / Detail Column (Centered) -->
                    <ng-container matColumnDef="Action">
                        <mat-header-cell class="grid-header text-center" *matHeaderCellDef> Detail </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center">
                            <span class="cursor-pointer text-primary" (click)="onViewBatchDetail(row)" title="View Batch Detail" style="cursor: pointer; font-size: 15px;">
                                <i class="fas fa-eye"></i>
                            </span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="batchDisplayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: batchDisplayedColumns"></mat-row>
                </mat-table>

                <mat-paginator #batchPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>

<!-- ==================== BATCH VOUCHER DETAILS MODAL ==================== -->
<div class="modal fade in" id="BatchVoucherDetailsModal" tabindex="-1" role="dialog" aria-labelledby="batchDetailModalLabel"
    data-backdrop="false" style="background-color: rgba(15, 23, 42, 0.55); overflow: auto; z-index: 9999 !important;">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content voucher-modal-content" id="BatchVoucherDetailPrint">

            <!-- Modal Header -->
            <div cdkDragHandle class="modal-header voucher-modal-header">
                <h6 class="modal-title" id="batchDetailModalLabel">
                    <i class="far fa-file-alt mr-2"></i> Batch Voucher Detail
                </h6>
                <button type="button" (click)="onCloseBatchDetailsModal()" class="close voucher-close-btn d-print-none" aria-label="Close">
                    <span aria-hidden="true"><i class="far fa-times-circle"></i></span>
                </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body voucher-modal-body">
                <!-- Voucher Type Banner -->
                <div class="row m-0 text-left">
                    <div class="col-md-12 voucher-type-banner">
                        <span class="voucher-type-label">Voucher Type</span>
                        <span class="voucher-type-value">
                            {{ batchSummaryHeader?.Voucher_Type || 'Repayment' }} —
                            {{ batchSummaryHeader?.Voucher_Sub_Type || 'Loan' }}
                        </span>
                    </div>
                </div>

                <!-- Meta Info Cards -->
                <div class="row m-0 mt-2 voucher-meta-row">
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Batch No</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_No || batchSummaryHeader?.Batch_no || '-' }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Created By</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_CreateBy || '-' }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Created On</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_CreateOn || '-' }}</span>
                        </div>
                    </div>
                </div>

                <!-- Details Table -->
                <div class="row m-0 mt-3">
                    <div class="col-md-12 p-0">
                        <div class="table-responsive voucher-table-wrapper">
                            <table class="table w-100 m-0 voucher-table">
                                <thead>
                                    <tr>
                                        <th style="width: 7%; text-align: center;">Voucher No</th>
                                        <th style="width: 6%; text-align: center;">Type</th>
                                        <th style="width: 13%; text-align: center;">Case No</th>
                                        <th style="width: 15%; text-align: center;">Customer</th>
                                        <th style="width: 12%; text-align: center;">Branch</th>
                                        <th style="width: 15%; text-align: center;">Category</th>
                                        <th style="width: 15%; text-align: center;">Account Head</th>
                                        <th style="width: 8.5%; text-align: center;">Amount (DR)</th>
                                        <th style="width: 8.5%; text-align: center;">Amount (CR)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of batchVoucherDetailsList" [ngClass]="row.groupClass">
                                        <ng-container *ngIf="!row.isGroupTotal">
                                            <td style="text-align: center;" class="fw-600">{{ row.Voucher_No }}</td>
                                            <td style="text-align: center;">
                                                <span class="type-badge" [ngClass]="row.TranType === 'DR' ? 'badge-dr' : 'badge-cr'">
                                                    {{ row.TranType }}
                                                </span>
                                            </td>
                                            <td style="text-align: center;">{{ row.CaseNo || '-' }}</td>
                                            <td style="text-align: center;">{{ row.Customer || '-' }}</td>
                                            <td style="text-align: center;">{{ row.Branch_Name || '-' }}</td>
                                            <td style="text-align: center;">{{ row.ChagesHead || row.ChargeHeadCategory || '-' }}</td>
                                            <td style="text-align: center;">{{ row.Account_Name || row.ChargeHeadCategory || '-' }}</td>
                                            <td style="text-align: center;" class="amount-dr">
                                                {{ row.AmountDR ? (row.AmountDR | number:'1.2-2') : '' }}
                                            </td>
                                            <td style="text-align: center;" class="amount-cr">
                                                {{ row.AmountCR ? (row.AmountCR | number:'1.2-2') : '' }}
                                            </td>
                                        </ng-container>
                                        <ng-container *ngIf="row.isGroupTotal">
                                            <td colspan="6" class="fw-600 text-center px-3">
                                                <span *ngIf="row.Voucher_Date">Voucher Date: {{ formatDateOnly(row.Voucher_Date) }}</span>
                                            </td>
                                            <td class="fw-700 text-center">Total</td>
                                            <td style="text-align: center;" class="fw-700 amount-dr">
                                                {{ row.AmountDR | number:'1.2-2' }}
                                            </td>
                                            <td style="text-align: center;" class="fw-700 amount-cr">
                                                {{ row.AmountCR | number:'1.2-2' }}
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr *ngIf="!batchVoucherDetailsList || batchVoucherDetailsList.length === 0">
                                        <td colspan="9" class="text-center p-4 text-muted">
                                            <i class="far fa-folder-open mr-1"></i> No details found for this batch voucher.
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="voucher-total-row">
                                        <td colspan="7" style="text-align: center;" class="fw-700">Total</td>
                                        <td style="text-align: center;" class="amount-dr fw-700">
                                            {{ calculateBatchTotalDR() | number:'1.2-2' }}
                                        </td>
                                        <td style="text-align: center;" class="amount-cr fw-700">
                                            {{ calculateBatchTotalCR() | number:'1.2-2' }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Narration & Meta Footer -->
                <div class="row m-0 mt-3 text-left voucher-footer-info">
                    <div class="col-md-12 p-2">
                        <h6 class="section-label">Voucher Narration</h6>
                        <p class="section-value">
                            {{ batchSummaryHeader?.Narration || batchSummaryHeader?.Batch_no || '-' }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Modal Footer (Action Controls & Remark) -->
            <div class="modal-footer voucher-modal-footer no-print d-print-none flex-column align-items-stretch">
                <div class="row m-0 w-100 mb-2 text-left">
                    <div class="col-md-12 p-0">
                        <h6 class="section-label mb-1">Remark <span class="text-danger">*</span></h6>
                        <input type="text" class="form-control font-size-12" [(ngModel)]="batchActionRemark" name="batchActionRemark"
                            placeholder="Enter Remark for Authorization or Rejection" />
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex">
                        <button type="button" class="btn btn-success font-size-12 mr-2" (click)="onBatchActionFromDetail('Authorized')"
                            [class.spinner]="showSpinner">
                            <i class="fas fa-check mr-1"></i> Authorize
                        </button>
                        <button type="button" class="btn btn-danger font-size-12" (click)="onBatchActionFromDetail('Rejected')"
                            [class.spinner]="showSpinner">
                            <i class="fas fa-times mr-1"></i> Reject
                        </button>
                    </div>
                    <div>
                        <button type="button" class="btn voucher-btn voucher-btn-primary mr-2" (click)="PrintBatchDoc('BatchVoucherDetailPrint', 'Voucher Detail')">
                            <i class="fas fa-print mr-1"></i> Print View
                        </button>
                        <button type="button" class="btn btn-secondary font-size-12" (click)="onCloseBatchDetailsModal()">
                            Close
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- ==================== INDIVIDUAL MODALS ==================== -->
<div class="modal fade in" id="AuthorizeRemarkModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content custom-delete-modal">

            <div class="modal-body text-center">

                <h5 class="delete-title">
                    Are you sure you want to authorize selected Vouchers?
                </h5>

                <div class="mt-3 text-left">
                    <label class="remark-label">Enter Reason for Authorizing</label>
                    <input name="AuthorizeRemark" [(ngModel)]="AuthorizeRemark" id="AuthorizeRemark"
                        placeholder="Enter Remark" class="form-control remark-input" />
                </div>

            </div>

            <div class="modal-footer custom-footer">
                <button class="btn btn-no" (click)="CloseAuthorizeRemarkModal()">
                    NO
                </button>

                <button class="btn btn-yes" (click)="ConfirmAuthorizeVouchers()" [class.spinner]="showSpinner">
                    YES
                </button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade in" id="RejectRemarkModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content custom-delete-modal">

            <div class="modal-body text-center">

                <h5 class="delete-title">
                    Are you sure you want to reject selected Vouchers?
                </h5>

                <div class="mt-3 text-left">
                    <label class="remark-label">Enter Reason for Rejecting</label>
                    <input name="RejectRemark" [(ngModel)]="RejectRemark" id="RejectRemark" placeholder="Enter Remark"
                        class="form-control remark-input" />
                </div>

            </div>

            <div class="modal-footer custom-footer">
                <button class="btn btn-no" (click)="CloseRejectRemarkModal()">
                    NO
                </button>

                <button class="btn btn-yes" (click)="ConfirmRejectVouchers()" [class.spinner]="showSpinner">
                    YES
                </button>
            </div>

        </div>
    </div>
</div>